export default "__VITE_ASSET__D7tM1dsS__"